import style from './style.module.css';
import Container from '../common/container';
import { Key } from 'react';
import Image from 'next/image';

const DigitizeBusiness = ({ bussinessValues, CrossHeadsItems, showBusinessExperinces }: any) => {
   const { title, subtitle, businessValues } = bussinessValues;

   const businessExperinces = [
      {
         number: '1',
         text: 'Fill out the company information',
      },
      {
         number: '2',
         text: 'Mention any specific requirements or requests',
      },
      {
         number: '3',
         text: 'Set the experience’s type (Virtually or in-person)',
      },
      {
         number: '4',
         text: 'Specify the number of employees per experience',
      },
      {
         number: '5',
         text: 'Pick an experience or get a suggestion',
      },
      {
         number: '6',
         text: 'Plan your unique custom experience & itinerary',
      },
   ];

   return (
      <div className={`${style['gray-bg']}`}>
         <Container>
            <div className="lg:flex  lg:pt-[109px] lg:pb-[118px] py-10">
               <div className=" font-semibold lg:w-1/3 text-[30px] lg:text-[50px]  leading-[30px]  lg:leading-[54px] mb-8 text-center lg:ltr:text-left lg:rtl:text-right">
                  {title}
                  <div className="text-[#0552BC]"> {subtitle}</div>
               </div>
               <div className="lg:grid gap-10 lg:grid-cols-3  ">
                  {businessValues.map(({ icon, name }: any, key: Key) => (
                     <div key={key} className="grid text-center justify-items-center">
                        <div className=" ">{icon}</div>
                        <div>
                           <div className=" mb-2 text-[16px] lg:text-[24px] font-semibold leading-8 h-[90px] w-52 sm:w-56 ">
                              {name}
                           </div>
                        </div>
                     </div>
                  ))}
               </div>
            </div>

            <hr />

            <div>
               {CrossHeadsItems?.map(({ image, title, description }: any, index: number) => {
                  const isEven = index % 2 === 0;
                  return (
                     <div key={index} className="last:pb-2">
                        {!isEven ? (
                           <div className="grid text-center lg:text-left lg:grid-cols-2 gap-[110px] my-[100px] items-center">
                              <div className="space-y-4 ">
                                 <div className="font-bold text-[50px] leading-[60px]">
                                    {title}{' '}
                                 </div>
                                 <div className="text-[#495057] font-normal leading-[30px] text-[24px]">
                                    {description}
                                 </div>
                              </div>
                              <div className="lg:order-1 order-[2]">
                                 <Image src={image} width="740" height="560" alt="" />
                              </div>
                           </div>
                        ) : (
                           <div className="grid text-center lg:text-left lg:grid-cols-2 gap-[110px] mt-[75px] items-center">
                              <div className="lg:order-1 order-[2]">
                                 <Image src={image} width="610" height="432" alt="" />
                              </div>
                              <div className="lg:order-2 space-y-4">
                                 <div className="font-bold text-[50px] leading-[60px]">{title}</div>
                                 <div className="text-[#495057] font-medium leading-[30px] text-[24px]">
                                    {description}
                                 </div>
                              </div>
                           </div>
                        )}
                     </div>
                  );
               })}
            </div>

            {showBusinessExperinces && (
               <>
                  <hr />

                  <div className="mt-[55px] space-y-[60px] pb-[100px]">
                     <div className="font-bold leading-[60px] text-[40px] text-center">
                        Here at Hala Yalla, we will help you create & organize effortless
                        team-building experiences.
                     </div>

                     <div className="grid lg:grid-rows-2 lg:grid-cols-3 gap-x-[25px] gap-y-[15px]">
                        {businessExperinces?.map(({ number, text }, index) => {
                           return (
                              <div
                                 key={index}
                                 className="flex items-center min-h-[115px] bg-white gap-[30px] p-[30px] rounded-[8px] w-full relative before:w-[6px] before:bg-[#1D4ED8] before:h-full before:absolute before:left-0 before:top-0 before:rounded-tl-[8px] before:rounded-bl-[8px]">
                                 <span className="font-black italic text-black opacity-[0.15] text-[73px] leading-[30px] tracking-[-0.5px]">
                                    {number}
                                 </span>
                                 <span className="font-normal text-[#495057] leading-[30px] text-[18px] ">
                                    {text}
                                 </span>
                              </div>
                           );
                        })}
                     </div>
                  </div>
               </>
            )}
         </Container>
      </div>
   );
};
export default DigitizeBusiness;
